"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gutter = void 0;
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = size => ({
    root: {
        flex: 0,
        padding: 4 * size,
    },
});
function Gutter(props) {
    const { style, size = 1 } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [size]);
    return react_1.default.createElement("div", { style: style, className: myCss.root });
}
exports.Gutter = Gutter;
exports.default = Gutter;
